
const HelpData = [
    {
        category: "Getting Started",
        tabs: [
            { title: "Introduction", link: "/docs/introduction" },
            { title: "Learner Dashboard", link: "/docs/learner-dashboard" },
            { title: "Contributor Dashboard", link: "/docs/contributor-dashboard" },
            { title: "Parent Dashboard", link: "/docs/parent-dashboard" },
            { title: "Teacher Dashboard", link: "/docs/teacher-dashboard" },
        ],
    },
];

export default HelpData;
